/* eslint-disable react/jsx-key */
import React, { useState } from 'react'
import { strCol, intCol } from '@integec/grid-tools/lib/cols'
import { getApiTargetInfo } from 'core'
import { modifierCol, modifiedDateCol } from 'core/HeaderColTypeProps'
import { connect } from 'react-redux'
import {
  getMonthlyLock,
  updateMonthlyLock,
  deleteMonthlyLock,
} from 'api/pgads.js'
import { Input, Button, InputNumber } from 'antd'
// import R from 'ramda'
import CommonScreen from './CommonScreen'
// import { toSelectionColProps } from '@integec/grid-tools/lib/utils'

// const days = R.range(1, 32)
// const daysMap = days
// .map(n => ({ [n + '']: n + '' }))
// .reduce((a, b) => ({ ...a, ...b }))
// .map(i => ({ [i + '']: i + '' }))
// .reduce((a, b) => ({ ...a, ...b }))
// .sort((a, b) => parseInt(a) - parseInt(b))

// const toSelectProps = keyValues => {
//   const choices = []
//   keyValues.forEach((value, key) => {
//     return choices.push({
//       text: value + '',
//       value: key + 1,
//     })
//   })
//   choices.sort((a, b) => a.value - b.value)
//   return {
//     choices,
//     dataFormatter: function dataFormatter(_ref5) {
//       const value = _ref5.value
//       return value + ''
//       // return keyValues.has(value) ? keyValues.get(value) : value
//     },
//   }
// }

const headers = [
  strCol({
    ident: 'monthlyLock',
    display: 'Monthly Lock',
    isKey: true,
    width: 150,
    isFiltered: true,
  }),
  intCol({
    ident: 'lockOutDay',
    display: 'Lock Out Day',
    // ...toSelectProps(days),
    // ...toSelectionColProps(daysMap),
    isRequired: true,
    isFiltered: true,
  }),
  modifierCol,
  modifiedDateCol,
]

const retrieveTask = apiTargetInfo => getMonthlyLock(apiTargetInfo)

const modifyTask = apiTargetInfo => data =>
  updateMonthlyLock(apiTargetInfo)(data)

const deleteTask = apiTargetInfo => data =>
  deleteMonthlyLock(apiTargetInfo)(data)

const title = 'Monthly Lock Management'

const MonthlyLockMgmt = () => {
  const [insertEvent, setInsertEvent] = useState(false)
  // const [insertData, setInsertData] = useState({})

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => (
    <div
      style={{
        width: '100%',
        display: 'flex',
      }}
    >
      <div
        style={{
          width: '120px',
          display: 'grid',
          alignContent: 'center',
          marginLeft: '20px',
        }}
      >
        Monthly Lock :{' '}
      </div>
      <Input
        placeholder="Monthly Lock"
        style={{ width: '200px' }}
        value={insertData.monthlyLock}
        // onChange={e => setData({ monthlyLock: e.target.value })}
        onChange={e =>
          setInsertData({ ...insertData, monthlyLock: e.target.value })
        }
      />

      <div
        style={{
          marginLeft: '50px',
          width: '100px',
          display: 'grid',
          alignContent: 'center',
        }}
      >
        Lock Out Day:{' '}
      </div>
      <InputNumber
        placeholder="Lock Out Day"
        defaultValue={0}
        onChange={value => setInsertData({ ...insertData, lockOutDay: value })}
        min={0}
        value={insertData.lockOutDay}
      />
      {/* <Select
        style={{ width: '150px' }}
        placeholder="Select a Day"
        value={insertData.lockOutDay}
        // onChange={value => {
        //   //setData({ lockOutDay: value })
        //   onChange={e=>setInsertData({...insertData,lockOutDay:value})}
        // }}
        onChange={value => setInsertData({ ...insertData, lockOutDay: value })}
      >
        {days.map(i => (
          <Select.Option value={i}>{i}</Select.Option>
        ))}
      </Select> */}

      <Button
        type="primary"
        style={{ marginLeft: '50px' }}
        // onClick={() => onAdd({ hide: false, retrieve, data, setInsertData, insertData })}
        onClick={() => onAdd(true)}
      >
        Add
      </Button>
      <Button
        type="primary"
        style={{ marginLeft: '50px' }}
        // onClick={() => onAdd({ hide: true, retrieve, data, setInsertData, insertData })}
        onClick={() => onAdd(false)}
      >
        Add & Hide
      </Button>
      <Button type="danger" onClick={onCancel} style={{ marginLeft: '50px' }}>
        Cancel
      </Button>
    </div>
  )

  // const setData = data => {
  //   setInsertData({ ...insertData, ...data })
  // }
  // const onCancel = () => {
  //   setInsertEvent(false)
  // }
  // const validateData = data => {
  //   const { monthlyLock, lockOutDay } = insertData
  //   if (data.find(d => d.monthlyLock === insertData.monthlyLock))
  //     message.error('Same Monthly Lock Name avaliable,Please')
  //   else if (monthlyLock === undefined) message.error('Please, Insert Monthly Lock Name to Save')
  //   else if (lockOutDay === undefined) message.error('Please, Insert Lock Out Day to Save')
  //   else return true
  //   return false
  // }

  // const onAdd = ({ hide, retrieve, data }) => {
  //   const validate = validateData(data)
  //   if (validate)
  //     modifyTask(apiTargetInfo)([insertData]).fork(setErr, _ => {
  //       message.info('Data Saved')
  //       setInsertData({})
  //       setInsertEvent(!hide)
  //       retrieve && retrieve()
  //     })
  // }

  return [
    <CommonScreen
      title={title}
      header={headers}
      saveTask={modifyTask}
      retrieveTask={retrieveTask}
      deleteTask={deleteTask}
      altBy={d => d.unit}
      autoRetrieve
      sortOptions={[
        { ident: 'monthlyLock', display: 'Monthly Lock', sortOrder: 'asc' },
      ]}
      widthOffset={650}
      insertComp={insertEvent && insertComp}
      insertCompHeight={90}
      onInsertEvent={b => setInsertEvent(b)}
      allowInsert={false}
      withDelete={false}
    />,
  ]
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
})

export default connect(mapStateToProps)(MonthlyLockMgmt)
